import { configureStore } from '@reduxjs/toolkit';

import { useSelector } from 'react-redux';

import LotteryCountersSlice from './Slicers/LotteryCountersSlice';
import ModulesSlice from './Slicers/ModulesSlice';
import UserSlice from './Slicers/UserSlice';
import WindowSlice from './Slicers/WindowSlice';

const GlobalStore = configureStore({
    reducer: {
        lotteryCounters: LotteryCountersSlice,
        user: UserSlice,
        window: WindowSlice,
        modules: ModulesSlice,
    },
});

export default GlobalStore;

type GlobalStoreState = ReturnType<typeof GlobalStore.getState>;

export const useGlobalStoreSelector = <TSelected>(
    selector: (state: GlobalStoreState) => TSelected,
    equalityFn?: (left: TSelected, right: TSelected) => boolean
) => useSelector(selector, equalityFn);
